<div
  *ngIf="primaryDataset"
  class="unique-visits-chart">
  <canvas
    #paymentsChart
    class="unique-visits-chart__canvas"
    data-cy="unique-visits-chart.canvas">
  </canvas>

  <coa-multiple-series-chart-tooltip
    #tooltip
    [clientId]="clientId"
    [tooltip]="currentTooltip"
    class="unique-visits-chart__tooltip">
  </coa-multiple-series-chart-tooltip>
</div>

